// extracted by mini-css-extract-plugin
module.exports = {"container":"collapsablePanel_container__3bMAk","button":"collapsablePanel_button__3ZKy1"};